import classnames from 'classnames';
import type { IWithQuoteFormWrapperProps } from 'components/shared/WithQuoteFormWrapper/WithQuoteFormWrapper';
import { WithQuoteFormWrapper } from 'components/shared/WithQuoteFormWrapper/WithQuoteFormWrapper';
import { ChangeEvent, FC, FocusEvent } from 'react';
import Skeleton from 'react-loading-skeleton';

export interface ITextFieldProps {
  className?: string;
  hasError?: boolean;
  id: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isReadOnly?: boolean;
  label?: string;
  name?: string;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  tabIndex?: number;
  type?: string;
  value?: string | number;
  isEdited?: boolean;
}

type TextFieldWithLabelProps = ITextFieldProps & IWithQuoteFormWrapperProps;

export const TextField: FC<ITextFieldProps> = props => {
  return (
    <>
      {props.isEdited && <i className="icon text-info input-group-text  icon-sm">fiber_manual_record</i>}
      <input
        className={classnames('text-field-component', 'form-control', props.className, {
          'is-warning': props.hasError,
          'border border-info': props.isLoading,
          'text-info': props.isEdited,
          'fw-medium': props.isEdited,
          error: props.hasError,
        })}
        id={props.id}
        data-e2e={`${props.id}-input`}
        data-e2e-loading={props.isLoading ? 'true' : undefined}
        disabled={props.isDisabled || false}
        readOnly={props.isReadOnly || false}
        name={props.name}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onChange={props.onChange}
        placeholder={props.placeholder}
        type={props.type || 'text'}
        value={props.value !== undefined && props.value !== null ? props.value : ''}
        tabIndex={props.tabIndex || 0}
      />
    </>
  );
};

export const TextFieldSkeleton: FC = () => {
  return (
    <div className="form-control disabled">
      <Skeleton width="7em" />
    </div>
  );
};
export const TextFieldWithLabel: FC<TextFieldWithLabelProps & { colSize?: number }> = (
  props: TextFieldWithLabelProps,
) => (
  <WithQuoteFormWrapper id={props.id} label={props.label} colSize={props.colSize || 5}>
    <TextField {...props} />
  </WithQuoteFormWrapper>
);
